import { EmpathyXConfig, QueryOrigin, RecommendationsState } from '../../models';

export function getInitialRecommendationsState(config: EmpathyXConfig): RecommendationsState {
  return {
    lastCount: 0,
    hasMore: true,
    loading: false,
    infiniteScrollEnabled: config.recommendations.infiniteScrollDefaultEnabled,
    page: 1,
    recommendations: [],
    origin: QueryOrigin.default
  };
}
